import { ProgramDescriptionAccordion } from '@components/buzzkuri/shared/uiParts/accordion/ProgramDescription'
import { GuestsVoice } from '@type/buzzkuri/programs-categor'
import React from 'react'
import { ParticipantsVoiceItem } from '../../top/PointSection/PointTabViwer/Contents/ParticipantsVoice/item'

type Props = {
  guestsVoices: GuestsVoice[]
}

export const GuestsVoicesSection = ({ guestsVoices }: Props): JSX.Element => (
  <div className="w-[87.2vw] lg:w-[62.6vw]">
    <ProgramDescriptionAccordion title="参加者の声">
      <div className="px-[4.8vw] pt-[9.2vw] lg:pt-[2.5vw] lg:pr-[4.3vw] pb-[7.8vw] lg:pb-[4.1vw] lg:pl-[1.6vw] bg-[#F7F6F5]">
        {guestsVoices.map((guestsVoice, i) => (
          <div
            key={i}
            className="last:mb-0 lg:mb-[2.7vw] w-[74.9vw] lg:w-[68vw]"
          >
            <ParticipantsVoiceItem
              content={guestsVoice.description}
              participantInfo={guestsVoice.guestInformation}
            />
          </div>
        ))}
      </div>
    </ProgramDescriptionAccordion>
  </div>
)
